import { useEffect } from 'react';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Typography from '@mui/material/Typography';
import IconLargeCicle from '../../shared/IconLargeCicle';
import Button from '@mui/material/Button';
import { dynamicCustomEventTracking } from '../../../lib/gtm';

export default function ExpiredConfirmationSchedule() {
  useEffect(() => {
    dynamicCustomEventTracking.send({ dynamicEventName: 'expired_confirmation_schedule_mc' });
  }, []);

  return (
    <>
      <IconLargeCicle>
        <SentimentDissatisfiedIcon />
      </IconLargeCicle>

      <Typography variant="h2" sx={{ mb: 3 }}>
        Ops! Esse link já expirou.
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Se precisa de ajuda ou tem alguma dúvida, entre em contato com nosso time de atendimento.
      </Typography>
      <Button variant="contained" endIcon={<WhatsAppIcon />} href="https://bit.ly/Fale_com_a_Oya" target="_blank">
        Fale com a gente
      </Button>
    </>
  );
}
